import { ReferentielCategoriesLieuState } from './types';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { getCategoriesLieuVaccination } from '@/services/api/referentiel/lieux/api';
import { CategorieLieuType } from '@/store/folder/types';
import _ from 'lodash';

const namespaced: boolean = true;

export const state: ReferentielCategoriesLieuState = {
	lieux: [],
	errorCode: '',
	error: false,
	loaded: false
};

export const mutations: MutationTree<ReferentielCategoriesLieuState> = {
	updateCategoriesLieuVaccination(state: ReferentielCategoriesLieuState, lieux: CategorieLieuType[]): void {
		state.lieux = lieux;
	},
	updateErrorCode(state: ReferentielCategoriesLieuState, errorCode: string): void {
		state.errorCode = errorCode;
	},
	updateError(state: ReferentielCategoriesLieuState, error: boolean): void {
		state.error = error;
	},
	updateLoaded(state: ReferentielCategoriesLieuState, loaded: boolean): void {
		state.loaded = loaded;
	}
};

export const actions: ActionTree<ReferentielCategoriesLieuState, RootState> = {
	loadCategoriesLieuVaccination(state): Promise<void> {
		return new Promise((resolve, reject) => {
			if (!state.state.loaded || state.state.error) {
				state.commit('updateCategoriesLieuVaccination', []);
				state.commit('updateError', false);
				state.commit('updateErrorCode', '');
				getCategoriesLieuVaccination()
					.then((response: any) => {
						state.commit('updateCategoriesLieuVaccination', _.get(response, 'data.value.lieux'));
						state.commit('updateLoaded', true);
						resolve();
					})
					.catch((error: any) => {
						state.commit('updateError', true);
						state.commit('updateLoaded', false);
						const err = _.get(error, 'response.data.value.errorCode');
						if (!_.isEmpty(err)) {
							state.commit('updateErrorCode', err);
						}
						reject();
					});
			} else {
				resolve();
			}
		});
	}
};

export const getters: GetterTree<ReferentielCategoriesLieuState, RootState> = {
	getCategoriesLieuVaccination(state) {
		return state.lieux;
	},
	getErrorCode(state) {
		return state.errorCode;
	},
	getError(state) {
		return state.error;
	}
};

export const referentielCategoriesLieu: Module<ReferentielCategoriesLieuState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
